module.exports = "<div class=\"overlay-backdrop\"></div>\n\n<div class=\"m-overlay\">\n\n\t<div class=\"c-overlay\">\n\t\t<div class=\"holder\">\n\t\t\t<div class=\"inner-holder\">\n\t\t\t\t<div class=\"button-holder\" data-ng-click=\"vm.overlayToggle()\">\n\t\t\t\t\t{{ vm.overlayButton }}\n\t\t\t\t\t<i class=\"grey-close-button\"></i>\n\t\t\t\t</div>\n\t\t\t\t<h4>{{ vm.overlayHeading }}</h4>\n\t\t\t\t<p>{{ vm.overlayText }} <a data-ng-href=\"{{ vm.pfwLink }}{{ vm.pfwTrackingNumber() }}\" target=\"_blank\">{{ vm.pfwWebsite }}</a></p>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/components/pfwOverlay/pfwOverlay.view.html
// module id = 58
// module chunks = 0